module.exports = __webpack_public_path__ + "img/logo-red.42b4945a.png";